import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ScrollToTop from './common/components/ScrollToTop';
import Header from './header/Header';
import Home from './home/Home';
import Calculator from './calculator/Calculator';
import CalculatorAdvanced from './calculator/advanced/CalculatorAdvanced';
import HowItWorks from './how-it-works/HowItWorks';
import About from './about/About';
import Phong from './phong/Phong';
import Terms from './terms/Terms';
import Disclaimer from './terms/Disclaimer';
import PrivacyPolicy from './terms/PrivacyPolicy';
import Investors from './investors/Investors';
import Footer from './footer/Footer';
import './App.css';
import Modal from "react-modal";
import { Amplify } from 'aws-amplify';
import config from './aws-exports';
//import ReactGA from 'react-ga';
import useGoogleAnalytics from './common/analytics/UseGoogleAnalytics';

Modal.setAppElement("#root");

Amplify.configure(config);
//ReactGA.initialize('G-QXB2JGEJDV');

function AppRoutes() {
  useGoogleAnalytics();

  return (
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path="debt-payoff-calculator" element={<Calculator />} />
      <Route path="calculator-advanced" element={<CalculatorAdvanced />} />
      <Route path="how-it-works" element={<HowItWorks />} />
      <Route path='/about-us' element={<About />} />
      <Route path='/phong-nguyen-founders-story' element={<Phong />} />
      <Route path='/terms-and-conditions' element={<Terms />} />
      <Route path='/disclaimer' element={<Disclaimer />} />
      <Route path='/privacy-policy' element={<PrivacyPolicy />} />
      <Route path='/investors' element={<Investors />} />
    </Routes>
  );

}

function App() {
  return (
    <BrowserRouter>
        <ScrollToTop />
        <Header />
        {/*
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path="debt-payoff-calculator" element={<Calculator />} />
          <Route path="calculator-advanced" element={<CalculatorAdvanced />} />
          <Route path='/about-us' element={<About />} />
          <Route path='/phong-nguyen-founders-story' element={<Phong />} />
          <Route path='/terms-and-conditions' element={<Terms />} />
          <Route path='/disclaimer' element={<Disclaimer />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        </Routes>
        */}
        <AppRoutes />
        <Footer />
    </BrowserRouter>
  );
}

export default App;
